import { styled } from "styled-components";

export function HeaderShadow({
  leftColumnWidth,
  shadowLeftColumn,
  show,
}: {
  leftColumnWidth: number;
  shadowLeftColumn: boolean;
  show: boolean;
}) {
  const height = 15;

  return (
    <HeaderShadowWrapper $height={height} $show={show}>
      <HeaderShadowGrid
        $templateColumns={
          shadowLeftColumn ? `0px 1fr` : `${leftColumnWidth}px 1fr`
        }
      >
        {/* This empty div allows us to adjust the grid of HeaderShadowGrid when the table is being horizontally scrolled. We want this so we can create the illusion that the property titles are overlapping HeaderShadowDrop */}
        <div />
        <HeaderShadowDrop />
      </HeaderShadowGrid>
    </HeaderShadowWrapper>
  );
}

const HeaderShadowDrop = styled.div`
  background: linear-gradient(to bottom, rgb(23 49 73 / 0.1), transparent);
`;

const HeaderShadowWrapper = styled.div<{ $height: number; $show: boolean }>`
  width: 100%;
  height: ${({ $height }) => $height}px;
  margin-bottom: ${({ $height }) => -$height}px;
  z-index: 2;
  position: relative;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  transition: opacity 0.2s;
  overflow-x: hidden;
`;

const HeaderShadowGrid = styled.div<{ $templateColumns: string }>`
  display: grid;
  grid-template-columns: ${({ $templateColumns }) => $templateColumns};
  height: 100%;
`;
